import React, { useState, useEffect } from "react";

//CSS
import "./unitPopups.css";
import "../../Pages/0PageStyles.css";

//Components
import Button from "../Other Components/button";
import InputField from "../Other Components/inputField";
import PageLoader from "../Other Components/pageLoader";
import MandatoryExplanation from "../Other Components/mandatoryExplanation";

//Functions and hooks
import { GetNextUnitID, CreateUnit } from "../../BackendAccess/UnitHooks";
import { useNotification } from "../../Contexts/NotificationContext";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useTranslation } from "react-i18next";

export default function UnitCreationPopup({ onCancel, onCreate }) {
  const [ID, setID] = useState();
  const [Name, setName] = useState();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageError, setPageError] = useState(null);

  const [createBtnDisabled, setCreateBtnDisabled] = useState(false);

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchInitialValues = async () => {
      setLoading(true);
      try {
        const [nextID, error] = await GetNextUnitID();
        if (error) {
          error.isPageError = true;
          setError(error);
        } else setID(nextID);
      } catch (err) {
        setError({
          err: t("server.Server error.", { ns: "error" }),
          errCode: 500,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchInitialValues();
  }, []);

  const handleIDChange = (e) => {
    const value = e;

    setID(value);
  };
  const handleNameChange = (e) => {
    const value = e;
    setName(value);
  };

  const OnCreate = async () => {
    showNotification(t("Creating unit...", { ns: "units" }), "info");
    setCreateBtnDisabled(true);
    try {
      const [data, error] = await CreateUnit(ID, Name);
      if (error) {
        setError(error);
        return;
      }
      showNotification(
        t("Unit created successfully!", { ns: "units" }),
        "success"
      );
      onCreate();
      onCancel();
    } catch (err) {
      setError({
        err: t("server.Server error.", { ns: "error" }),
        errCode: 500,
      });
    } finally {
      setCreateBtnDisabled(false);
    }
  };

  const clickOnCancel = () => {
    showNotification(t("Unit creation canceled.", { ns: "units" }), "info");
    onCancel();
  };
  return (
    <div className="input-popup">
      <div className="dimming-cover" />
      <div className="input-popup-container">
        <PageLoader loading={loading} error={pageError}>
          <div className="input-popup-fields-container units">
            <InputField
              placeholder={t("Example: 1001")}
              label={t("ID") + ":"}
              value={ID}
              onChange={handleIDChange}
              mandatory={true}
              readOnly={true}
            />
            <InputField
              placeholder={t("Example: kg", { ns: "units" })}
              label={t("Name") + ":"}
              value={Name}
              onChange={handleNameChange}
              mandatory={true}
            />
          </div>
          <MandatoryExplanation />

          <div className="btn-container">
            <Button
              btnMargin={"btn-default"}
              btnStyle="btn-positive"
              onClick={OnCreate}
              disabled={createBtnDisabled}
              acceptEnter={true}
              icon={"create"}
            >
              {t("Create")}
            </Button>
            <Button
              btnMargin={"btn-default"}
              btnStyle="btn-primary"
              onClick={clickOnCancel}
            >
              {t("Cancel")}
            </Button>
          </div>
        </PageLoader>
      </div>
    </div>
  );
}
